import React from 'react';

import { isLongEvent } from '@libs/EventDetails';
import { showDateNoTime, showDate, isAllDay, showTime, showDateNoTimeExtended } from '@libs/NwMoment';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import HorizontalPeriod from '@components/Dates/HorizontalPeriod';
import VerticalDate from '@components/Dates/VerticalDate';
import VerticalPeriod from '@components/Dates/VerticalPeriod';
import { EventDetailsWrapper } from '@components/EventDrawer/EventDrawerUi/EventUI';
import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';
import StyleVariables from '@components/Gui/StyleVariables';

import { useFollowUp } from './FollowUpContext';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const FollowUpDetails = () => {
    const { groupType, followUpData, followUpStyle, followUpSubType } = useFollowUp();

    const isGloballyCancelled = () => {
        if (followUpData.Cancel) {
            if (followUpData.RelatedEvents && followUpData.RelatedEvents.length > 0) {
                if (followUpData.RelatedEvents.every((e) => e.Cancel)) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }
        return false;
    };

    const firstColumnWidth = '8rem';

    return (
        <EventDetailsWrapper className={isGloballyCancelled() ? 'is-cancelled' : null}>
            {followUpData.Service && (
                <ResponsiveFlexContainer
                    columns={[
                        {
                            content: <p className="is-label">Service</p>,
                            isBorder: true,
                            width: firstColumnWidth,
                        },
                        {
                            content: <p className="is-content is-stronger is-uppercase">{followUpData.Service.Name}</p>,
                            isBorder: false,
                        },
                    ]}
                />
            )}
            {followUpData.Description && !groupType && (
                <ResponsiveFlexContainer
                    columns={[
                        {
                            content: <p className="is-label">Description</p>,
                            isBorder: true,
                            width: firstColumnWidth,
                        },
                        {
                            content: <p className="is-content small">{followUpData.Description}</p>,
                            isBorder: false,
                        },
                    ]}
                />
            )}
            <ResponsiveFlexContainer
                columns={[
                    {
                        content: <p className="is-label">Set Model As</p>,
                        isBorder: true,
                        width: firstColumnWidth,
                    },
                    {
                        content: (
                            <>
                                {followUpData.ModelNotAvailable ? (
                                    <FlexContainer gap=".5rem" alignItems="center">
                                        <NwIcon
                                            icon={byPrefixAndName.fass['do-not-enter']}
                                            style={{ color: StyleVariables.DangerColor }}
                                        />
                                        <p className="is-content">Busy</p>
                                    </FlexContainer>
                                ) : (
                                    <FlexContainer gap=".5rem" alignItems="center">
                                        <NwIcon
                                            icon={byPrefixAndName.fasl['calendar-check']}
                                            style={{ color: StyleVariables.SuccessColor }}
                                        />
                                        <p className="is-content">Available</p>
                                    </FlexContainer>
                                )}
                            </>
                        ),
                        isBorder: false,
                    },
                ]}
            />
        </EventDetailsWrapper>
    );
};

export default FollowUpDetails;
